import {Routes, RouterModule} from '@angular/router';

// tslint:disable-next-line:variable-name
export const FullLayout_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../authentication/authentication.module').then(m => m.AuthenticationModule)
  }
];
